import { NumberFormattingOptions } from './types';

export function getFormatString(options: NumberFormattingOptions) {
  const { decimals = 2, strict = false, comma = false } = options;

  const wholePart = comma ? '0,0' : '0';

  if (decimals <= 0) {
    return wholePart;
  }

  if (strict) {
    return wholePart + '.' + '0'.repeat(decimals);
  }

  return wholePart + '[.]' + '0'.repeat(decimals);
}
